import React from 'react';
import createReactClass from 'create-react-class';
import BaseMixin from './BaseMixin';
import StringCompareTerminalMixin from './StringCompareTerminalMixin';

const StringCompare = createReactClass({
  displayName: 'StringCompare',
  mixins: [BaseMixin, StringCompareTerminalMixin],

  selectChangeListener: function(data) {
    this.props.node.set("value", data.text);
  },

  render: function() {
    return (
      <div className="form-inline">
        { this.renderTerminalName() }
        { this.renderRelOp(this._getRelOpOptionFromMetaData()) }
        { this.renderValue(this._listEndpoint(), this.selectChangeListener) }
      </div>
    );
  },

  _getRelOpOptionFromMetaData: function() {
    return this._getMetaData().relOpConfig;
  },

  _getMetaData: function() {
    return this.props.metaData;
  },

  _listEndpoint: function() {
    if (this._getMetaData().selectorUrl) {
      return this._getMetaData().selectorUrl;
    } else if (this._getMetaData().selectorValues) {
      return this._getMetaData().selectorValues;
    }

    switch (this.props.node.attributes.terminal) {
    case "advertiser_campaign_name":
      return this.props.selectUrls.advertiserCampaignNamesUrl;
    case "signal":
    case "previous_signal":
      return this.props.selectUrls.signalNamesUrl;
    case "affiliate_name":
      return this.props.selectUrls.affiliateNamesUrl;
    case "media_type":
      return this.props.selectValues.mediaTypes;
    case "advertiser_name":
      return this.props.selectUrls.possibleAdvertiserNames;
    case "end_of_call_reason":
      return this.props.selectValues.endOfCallMethodTypes;
    case "transaction_type":
      return this.props.selectValues.transactionTypes;
    }
  }
});

export default StringCompare;
